import { render, staticRenderFns } from "./UserDetailBase.vue?vue&type=template&id=2e5cc7d0&scoped=true&"
import script from "./UserDetailBase.vue?vue&type=script&lang=js&"
export * from "./UserDetailBase.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailBase.vue?vue&type=style&index=0&id=2e5cc7d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5cc7d0",
  null
  
)

export default component.exports